import React from "react";

const AppleSvg = () => (
  <svg
    viewBox="0 0 82 101"
    css={`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.752 22.956c6.105 4.991 15.098 4.091 20.084-2.011 4.991-6.102 4.088-15.092-2.015-20.088L39.752 22.956z"
      fill="#6CA14D"
    />
    <path d="M38.525 32.47h4V14.741h-4V32.47z" fill="#E6832D" />
    <path
      d="M65.485 28.594h-49.92C6.104 36.013 0 47.519 0 60.47 0 82.86 18.145 101 40.525 101c22.381 0 40.525-18.14 40.525-40.53 0-12.951-6.103-24.457-15.565-31.876z"
      fill="#6DA14E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.525 96.3c-16.802 0-30.419-13.611-30.419-30.414 0-16.797 13.617-30.416 30.419-30.416 2.101 0 4.151.213 6.132.619-6.036 3.318-10.127 9.737-10.127 17.114 0 10.772 8.735 19.508 19.51 19.508 5.973 0 11.32-2.685 14.899-6.913v.088c0 16.803-13.616 30.414-30.414 30.414z"
      fill="#467A3C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.939 65.798c-.042-14.657-10.452-26.877-24.282-29.709a19.41 19.41 0 0 1 9.383-2.401c10.775 0 19.51 8.735 19.51 19.515 0 4.8-1.734 9.196-4.611 12.595z"
      fill="#50863E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.04 72.711c-10.775 0-19.51-8.736-19.51-19.508 0-7.377 4.091-13.796 10.127-17.114 13.83 2.832 24.24 15.052 24.282 29.709-3.579 4.228-8.926 6.913-14.899 6.913z"
      fill="#346332"
    />
  </svg>
);

export default AppleSvg;
